import { type Configuration, LogLevel } from '@azure/msal-browser';
import { getRequiredEnv } from './utils/get-required-env';
import { ENTRA_TENANT_ID } from './utils/get-environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: getRequiredEnv('VITE_MSAL_CLIENT_ID'),
    authority: `https://login.microsoftonline.com/${ENTRA_TENANT_ID}`,
    redirectUri: getRequiredEnv('VITE_WEBAPP_BASE_URL'),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
